import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step1 } from '../../../../shared/models/component-messages/blocCommun/divers/step1';
import { TypePers } from '../models/TypePers';
import { AutoCompleteService } from '../../../../shared/services/auto-complete.service';
@Component({
  selector: 'app-type-pers',
  templateUrl: './type-pers.component.html'
})
export class TypePersComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypePers';
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;
  @Input() formName: string;
	@Input() personnePhysique: TypePers;

  public optionsSelect: any[];
  public optionsSelectType = 'CIVILITE';

    public step1 = new Step1();

  constructor(private autoCompleteService : AutoCompleteService) { }

  public ngOnInit() {
    this.optionsSelect = this.autoCompleteService.getOptions(this.optionsSelectType);

    if(!this.personnePhysique) {
      this.personnePhysique = new TypePers();
    }
    if (this.personnePhysique.civilite === null) {
      this.personnePhysique.civilite = '';

    }
  }
  
  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }
  
  
}

